"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
exports.__esModule = true;
exports.CaseAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// React imports
var react_1 = __importDefault(require("react"));
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var svg_icons_1 = __importDefault(require("../svgs/svg-icons"));
var CaseAlertType = ui_common_1.commonEnums.CaseAlertType;
var DEFAULT_PROPS = {
    alertSize: 'md'
};
var alertIcon = (_a = {},
    _a[CaseAlertType.WARNING] = 'BiomeWarning',
    _a[CaseAlertType.ERROR] = 'BiomeWarning',
    _a[CaseAlertType.INFO] = 'BiomeInfo',
    _a);
var CaseAlert = /** @class */ (function (_super) {
    __extends(CaseAlert, _super);
    /**
     * Constructor method for class CaseAlert
     * @param {Accelerate.CaseAlertProps} props - Props object passed to CaseAlert component
     */
    function CaseAlert(props) {
        return _super.call(this, props) || this;
    }
    CaseAlert.prototype.render = function () {
        var props = __assign(__assign({}, DEFAULT_PROPS), this.props);
        var caseAlertClass = [
            'case-alert',
            'case-alert-' + props.alertSize,
            {
                'case-alert-warning': this.props.alertType === CaseAlertType.WARNING,
                'case-alert-error': this.props.alertType === CaseAlertType.ERROR,
                'case-alert-info': this.props.alertType === CaseAlertType.INFO
            }
        ];
        var caseAlertSidebar = [
            'case-alert-sidebar',
            {
                'case-alert-bg-warning': this.props.alertType === CaseAlertType.WARNING,
                'case-alert-bg-error': this.props.alertType === CaseAlertType.ERROR,
                'case-alert-bg-info': this.props.alertType === CaseAlertType.INFO
            }
        ];
        var alertIconClass = [
            {
                'case-alert-icon-warning': this.props.alertType === CaseAlertType.WARNING,
                'case-alert-icon-error': this.props.alertType === CaseAlertType.ERROR,
                'case-alert-icon-info': this.props.alertType === CaseAlertType.INFO
            }
        ];
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(caseAlertClass) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])(caseAlertSidebar) }, { children: (0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: alertIcon[this.props.alertType], svgIconClass: (0, classnames_1["default"])(alertIconClass), svgIconSize: "20" }) })), (0, jsx_runtime_1.jsx)("div", { children: this.props.children })] })));
    };
    return CaseAlert;
}(react_1["default"].Component));
exports.CaseAlert = CaseAlert;
//# sourceMappingURL=case-alert.js.map